import { render, staticRenderFns } from "./ChooseMap.vue?vue&type=template&id=23646322&scoped=true&"
import script from "./ChooseMap.vue?vue&type=script&lang=js&"
export * from "./ChooseMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23646322",
  null
  
)

export default component.exports